"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropdownText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledDropdownText = styled_components_1.default.p `
  border-right: ${({ option }) => option ? '' : `1px solid ${config_1.colors.grayText}`};
  color: ${config_1.colors.black};
  font: ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
  height: auto;
  margin-right: ${({ option }) => (option ? '' : '10px')};
  padding: ${({ option }) => (option ? '10px' : '0 10px 0 0')};
  text-align: left;
  width: 100%;

  &:hover,
  &:focus {
    background: ${({ option }) => (option ? config_1.colors.blurpleDropdown : '')};
  }
`;
